import React from "react";
import "./Loading.css";
import SiLogo from "../../assets/svg/siLogo.svg";

function Loading() {
  return (
    <div className="loadingContainer">
      <img
        className="rotate-scale-down loadingImage"
        src={SiLogo}
        alt="Loading..."
      />
    </div>
  );
}

export default Loading;
